import { render, staticRenderFns } from "./PushNotifications.vue?vue&type=template&id=e68456b2&scoped=true"
import script from "./PushNotifications.vue?vue&type=script&lang=js"
export * from "./PushNotifications.vue?vue&type=script&lang=js"
import style0 from "./PushNotifications.vue?vue&type=style&index=0&id=e68456b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68456b2",
  null
  
)

export default component.exports